import React, { useEffect } from "react";
import { formatNepaliDate } from "../exports/functions";

interface NepaliCalendarProps {
  onDateSelect?: (nepaliDate: string, englishDate?: string) => void;
}

const NepaliCalendar = ({ onDateSelect }: NepaliCalendarProps) => {
  useEffect(() => {
    const handleMessage = (
      ev: MessageEvent<{
        type: string;
        english: string;
        nepali: string;
      }>,
    ) => {
      if (typeof ev.data !== "object") return;
      if (ev.data.type !== "button-click") return;

      const formattedDate = formatNepaliDate(ev.data.nepali);

      onDateSelect?.(formattedDate, ev.data.english);
    };

    window.addEventListener("message", handleMessage);

    return () => window.removeEventListener("message", handleMessage);
  }, [onDateSelect]);

  return (
    <iframe
      src="https://calendar.scieverinc.com.np"
      title="Calendar"
      width="100%"
      height="100%"
      style={{
        border: "none",
      }}
    />
  );
};

export default NepaliCalendar;
